var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1295 7.33325H14.6666V3.87029C14.6666 2.74526 13.9204 1.83325 12.9999 1.83325H8.99992C8.07944 1.83325 7.33325 2.74526 7.33325 3.87029V7.33325H3.87029C2.74526 7.33325 1.83325 8.07944 1.83325 8.99992V12.9999C1.83325 13.9204 2.74526 14.6666 3.87029 14.6666H7.33325V18.1295C7.33325 19.2546 8.07944 20.1666 8.99992 20.1666H12.9999C13.9204 20.1666 14.6666 19.2546 14.6666 18.1295V14.6666H18.1295C19.2546 14.6666 20.1666 13.9204 20.1666 12.9999V8.99992C20.1666 8.07944 19.2546 7.33325 18.1295 7.33325ZM18.3333 9.16658H12.8333V3.66659H9.16658V9.16658H3.66659V12.8333H9.16658V18.3333H12.8333V12.8333H18.3333V9.16658Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.4608965355efaaf9ece1c07d2bbfafa7.svg";
export { ForwardRef as ReactComponent };